import { render } from "./ZarPayment.vue?vue&type=template&id=10472e0f&scoped=true"
import script from "./ZarPayment.vue?vue&type=script&lang=js"
export * from "./ZarPayment.vue?vue&type=script&lang=js"

import "./ZarPayment.vue?vue&type=style&index=0&id=10472e0f&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10472e0f"]])

export default __exports__